import React from 'react'

const UserIcon = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9034 0.616501C7.50911 1.0784 4.72596 3.54774 3.89266 6.83511C3.238 9.41728 3.84329 12.1675 5.51342 14.2008C5.79785 14.5475 6.49128 15.2339 6.79687 15.4737L6.97787 15.6136L6.70284 15.7264C6.25975 15.9074 5.42997 16.3317 4.93046 16.6326C3.19558 17.6834 1.71426 19.1046 0.59236 20.7944C0.114006 21.516 0 21.7758 0 22.1507C0 22.8947 0.57238 23.4412 1.34809 23.4377C1.88756 23.4353 2.2096 23.2038 2.63859 22.5045C3.82801 20.5687 5.7144 18.9761 7.84995 18.1052C10.5121 17.0298 13.4879 17.0298 16.1501 18.1052C18.2844 18.9761 20.1732 20.5699 21.3614 22.5045C21.7904 23.2038 22.1124 23.4353 22.6519 23.4377C23.4276 23.4412 24 22.8947 24 22.1507C24 21.7758 23.886 21.516 23.4076 20.7944C22.2857 19.1046 20.8044 17.6834 19.0695 16.6326C18.4978 16.2946 17.9059 15.992 17.2972 15.7264L17.0221 15.6136L17.2031 15.4737C17.5087 15.2339 18.2022 14.5475 18.4866 14.2008C20.7796 11.4106 20.9947 7.39809 19.0167 4.35166C18.0619 2.9047 16.6906 1.78139 15.084 1.13012C13.8441 0.63178 12.2386 0.434327 10.9034 0.616501ZM12.6347 3.22453C13.9225 3.37716 15.1225 3.95544 16.0443 4.86763C16.885 5.7116 17.4418 6.79665 17.6371 7.97179C17.8324 9.14694 17.6566 10.3537 17.1341 11.4243C16.6117 12.4949 15.7685 13.376 14.7219 13.945C13.6753 14.5141 12.4774 14.7428 11.2948 14.5993C10.002 14.4353 8.80355 13.836 7.89672 12.9002C6.98989 11.9643 6.42872 10.7475 6.30558 9.45019C6.13634 7.78829 6.75456 6.07233 7.95691 4.8688C8.5627 4.2605 9.29794 3.79672 10.1079 3.51203C10.9178 3.22734 11.7815 3.12906 12.6347 3.22453Z"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default UserIcon
